/**
 * uninstall 子命令：移除 BaskReport skill 在 AI 客户端上的装载。
 *
 *   - codebuddy / workbuddy：删除用户级目录链接（~/.{client}/skills/basksoft-ai，junction/symlink）。
 *   - claude / cursor：删除项目级文件（.claude/commands/baskreport.md、.cursor/rules/basksoft-ai.mdc），
 *     并提示这些文件可能被 git 跟踪，必要时需手动 git rm。
 */
import { Command } from "commander";
import * as path from "node:path";
import { fileURLToPath } from "node:url";
import { runUninstall, expandClients, KNOWN_CLIENTS, type Client } from "../install-skill.js";

export function registerUninstall(program: Command) {
  program
    .command("uninstall")
    .description("卸载 BaskReport skill：删除 AI 客户端上的链接 / 项目级文件。")
    .option(
      "--clients <list>",
      `逗号分隔的客户端列表，支持: ${KNOWN_CLIENTS.join(", ")} 或 all`,
      "all",
    )
    .option("--project-root <dir>", "项目级文件（claude/cursor）的删除目录；缺省为当前目录")
    .action((opts: { clients: string; projectRoot?: string }) => {
      const clients = expandClients(
        opts.clients.split(",").map((c) => c.trim()).filter(Boolean),
      ) as Client[];
      const projectRoot = opts.projectRoot ?? process.cwd();
      runUninstall(
        { clients, build: false, projectRoot },
        // CLI 运行于包内 dist/cli/，skillRoot 用包根（dist 的上一级）
        path.resolve(path.dirname(fileURLToPath(import.meta.url)), "..", ".."),
      );
    });
}
